import { render, staticRenderFns } from "./RatioContainer.vue?vue&type=template&id=30d143fa&scoped=true&lang=pug&functional=true&"
import script from "./RatioContainer.vue?vue&type=script&lang=js&"
export * from "./RatioContainer.vue?vue&type=script&lang=js&"
import style0 from "./RatioContainer.vue?vue&type=style&index=0&id=30d143fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../.yarn/$$virtual/vue-loader-virtual-5d68b12ba1/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "30d143fa",
  null
  
)

export default component.exports